/**
 * Copy for surfaces added in the rebuild. The original storefront strings live
 * in `copy.ts` and are frozen by `copy.test.ts`; nothing here replaces them.
 */
export const storeCopy = {
  shop: {
    title: 'Shop all',
    subtitle: 'Every piece in the Lick Back collection.',
    all: 'All',
    sortLabel: 'Sort by',
    sort: {
      featured: 'Featured',
      newest: 'Newest',
      priceAsc: 'Price: low to high',
      priceDesc: 'Price: high to low',
    },
    count: (total: number) => `${total} piece${total === 1 ? '' : 's'}`,
    empty: 'Nothing in this collection yet.',
    clear: 'Show everything',
    viewAll: 'View all',
    back: 'Back to the collection',
  },

  collections: {
    label: 'Collections',
    title: 'Shop by collection',
    action: (label: string) => `Shop ${label}`,
  },

  trust: [
    {
      title: 'M-Pesa checkout',
      text: 'Pay in seconds with the number you already use.',
    },
    {
      title: 'Official collection',
      text: 'Every piece is made for the Lick Back drop.',
    },
    {
      title: 'Order confirmed',
      text: 'Your order is confirmed the moment payment lands.',
    },
  ],

  sizeGuide: {
    open: 'Size guide',
    title: 'Size guide',
    note: 'Measurements are garment chest width in centimetres. Between sizes, take the larger one.',
    columns: ['Size', 'Chest (cm)', 'Length (cm)'],
    rows: [
      ['S', '50', '69'],
      ['M', '53', '72'],
      ['L', '56', '74'],
      ['XL', '59', '76'],
      ['XXL', '62', '78'],
    ],
  },
} as const;
